export const getDocumentMeta = (name: string): string | null => {
  const metaTag: HTMLMetaElement | null = document.querySelector(
    `meta[name='${name}']`
  );

  return metaTag?.content || null;
};
